import http from './http';

export const getAllWidgets = async (month, year) => {
  try {
    const response = await http.get('/dashboard/widgets', {
      params: { month, year }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener widgets del dashboard:', error);
    throw error;
  }
};

export const getDashboardChart = async ({ period, category, month, year }) => {
  try {
    const params = {
      period,
      category,
    };

    if (typeof month === 'number') {
      params.month = month;
    }

    if (typeof year === 'number') {
      params.year = year;
    }

    const response = await http.get('/dashboard/chart', {
      params,
    });

    return response.data;
  } catch (error) {
    console.error('Error al obtener la grafica del dashboard:', error);
    throw error;
  }
};

export const normalizeDashboardData = (raw) => {
  return {
    users: {
      active: raw?.users?.active ?? 0,
      newThisMonth: raw?.users?.newThisMonth ?? 0,
      inactive: raw?.users?.inactive ?? 0
    },
    subscriptions: {
      newThisMonth: raw?.subscriptions?.newThisMonth ?? 0,
      revenueThisMonth: raw?.subscriptions?.revenueThisMonth ?? 0,
      notRenewed: raw?.subscriptions?.notRenewed ?? 0
    },
    favoriteRoutines: Array.isArray(raw?.favoriteRoutines)
      ? raw.favoriteRoutines
      : []
  };
};

const normalizeChartPoint = (point, index) => {
  return {
    key: point?.key ?? `item-${index + 1}`,
    label: typeof point?.label === 'string' ? point.label : `${point?.label ?? ''}`,
    shortLabel:
      typeof point?.shortLabel === 'string'
        ? point.shortLabel
        : `${point?.shortLabel ?? point?.label ?? ''}`,
    year: Number(point?.year ?? 0),
    month: point?.month !== null && point?.month !== undefined ? Number(point.month) : null,
    value: Number(point?.value ?? 0),
    order: Number(point?.order ?? index + 1),
    startDate: point?.startDate ?? null,
    endDate: point?.endDate ?? null,
  };
};

export const normalizeDashboardChartData = (raw) => {
  const now = new Date();

  const series = Array.isArray(raw?.series)
    ? raw.series.map((point, index) => normalizeChartPoint(point, index)).sort((a, b) => a.order - b.order)
    : [];

  return {
    period: typeof raw?.period === 'string' ? raw.period : 'last_12_months',
    category: typeof raw?.category === 'string' ? raw.category : 'users_new',
    categoryLabel: typeof raw?.categoryLabel === 'string' ? raw.categoryLabel : 'Usuarios nuevos',
    granularity: raw?.granularity === 'year' ? 'year' : 'month',
    total: Number(raw?.total ?? 0),
    max: Number(raw?.max ?? 0),
    min: Number(raw?.min ?? 0),
    anchor: {
      month: Number(raw?.anchor?.month ?? now.getMonth() + 1),
      year: Number(raw?.anchor?.year ?? now.getFullYear()),
    },
    series,
  };
};